export default __webpack_public_path__ + "static/media/neon_watch.3ac79f40.svg";